import { Box, Button } from "@mui/material";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { Views } from "react-big-calendar";

export default function AvailabilityCalendarNavigationPanel({ onNavigate, onView, currentView }) {

    const getVariant = (view) => (currentView === view ? 'contained' : 'outlined');
    const getColor = (view) => (currentView === view ? 'primary' : 'inherit');

    return (
        <Box>
            <Button className="icon-button-style" variant='contained' size='small' onClick={() => onNavigate('PREV')} endIcon={<ArrowBackIosIcon />} />
            <Button className="icon-button-style" variant='contained' size='small' onClick={() => onNavigate('NEXT')} endIcon={<ArrowForwardIosIcon />} />
            <Button className="button-style" size='small' variant={getVariant(Views.MONTH)} color={getColor(Views.MONTH)} onClick={() => onView(Views.MONTH)}>Month</Button>
            <Button className="button-style" size='small' variant={getVariant(Views.WEEK)} color={getColor(Views.WEEK)} onClick={() => onView(Views.WEEK)}>Week</Button>
        </Box>
    );
}